import { h, Fragment } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import { Modal } from './Modal'


export function useExpired(expires) {

	const [expired, setExpired] = useState(false)
	const [secondsUntilExpiry, setSecondsUntilExpiry] = useState()

	const update = () => {
		const now = Math.floor(Date.now()/1000)
		if (now >= expires) setExpired(true)
		setSecondsUntilExpiry(Math.max(0, expires - now))
	}

	useEffect(() => {
		update()
		const interval = setInterval(update, 1000);
		return () => clearInterval(interval)
	}, [expires])

	return [expired, secondsUntilExpiry]
}


export function ExpiryCounter({ expires, onExtend = () => {} }) {

	const [expired, secondsUntilExpiry] = useExpired(expires)
	const hours = Math.floor(secondsUntilExpiry / 3600)
	const minutes = Math.floor(secondsUntilExpiry / 60)
	const seconds = secondsUntilExpiry % 60
	const s = int => (int === 1) ? '' : 's'

	const hoursString = hours >= 1 && `${hours} hour${s(hours)}`
	const minutesString = minutes > 0 && `${minutes} minute${s(minutes)} and`
	const secondsString = `${seconds} second${s(seconds)}`
	const string = [hoursString, minutesString, secondsString].filter(Boolean).join(' ')

	return <>
		<Modal onClose={onExtend} open={!expired && secondsUntilExpiry < 60 * 10}>
			<h4 class="heading-4">Session inactivity</h4>
			<p>Your session will expire in <strong>{string}</strong>. <br />If you’d like to continue, please press the button below.</p>
			<button onClick={onExtend} type="button" class="button button--fill button--yellow">Continue</button>
		</Modal>
		<Modal open={expired}>
			<h4 class="heading-4">Session inactivity</h4>
			<p>Your session has expired. To start a new submission, please retry.</p>
			<a href="/" class="button button--fill button--grey">Home page</a>
		</Modal>
	</>
}
